import React, { useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome} from "@fortawesome/fontawesome-free-solid";

const months = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];

export default function NewsletterEntry() {
    const { year, month } = useParams();
    const [content, setContent] = useState("");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/${year}/${month}`)
            .then(res => setContent(res.data.content || ""))
            .catch(err => {
                if (err.response && err.response.status === 404) {
                    setContent("<em>Dieser Newsletter ist noch nicht veröffentlicht.</em>");
                } else {
                    setContent("<em>Fehler beim Laden.</em>");
                }
            });
    }, [year, month]);

    return (
        <div className="bg-gray-200 pt-24 bg-center">
            <Navbar />
            <div className="m-12"></div>

            <div className="flex flex-col md:flex-row md:items-center md:justify-between px-4">
                <div className="my-4 text-center md:text-left">
                    <h1 className="text-4xl md:text-6xl inline-block uppercase font-bold
            bg-gradient-to-r from-gray-800 to-gray-500 text-transparent bg-clip-text">
                        {months[Number(month)-1]}
                    </h1>
                    <h1 className="text-4xl md:text-6xl md:ml-4 ml-2 inline-block font-bold
            bg-gradient-to-r from-blue-500 to-blue-800 text-transparent bg-clip-text">
                        {year}
                    </h1>
                </div>

                <Link
                    to="/newsletter"
                    className="flex justify-center items-center mt-4 md:mt-0
            bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold
            py-2 px-4 rounded w-full md:w-auto"
                >
                    <FontAwesomeIcon icon={faHome} className="w-4 h-4 mr-2" />
                    <span>Zurück</span>
                </Link>
            </div>

            <div className="m-12"></div>
            <div className="prose lg:prose-lg mx-auto w-11/12 md:w-3/4" dangerouslySetInnerHTML={{ __html: content }} />
            <div className="m-12"></div>
            <Footer />
        </div>
    );
}
